import styled from 'styled-components';
import { bg, color } from '@lendi-ui/color';
import Tabs from '@lendi-ui/tabs';

export const TabsWrapper = styled.div`
  ${bg('shade.25')};
  border-bottom: 1px solid ${color('shade.100')};
`;

export const InspireTabs = styled(Tabs)`
  min-height: 48px;
`;

export const InspireTab = styled(Tabs.Tab)`
  min-width: 120px;

  flex-basis: 12.5%;
`;
